export default ngModule => {
  ngModule.controller('ComparatorStep3CtrlRTE', function (AonConfig, OperatorService, $scope) {
    
    let ctrl = $scope.$parent.ctrl;
    const { PaymentFrequenciesLookup, PaymentMethodsLookup } = AonConfig.jsConstants;
    const AMBULANCE_COVER_SCRIPTS = {
      TAS: {
        title: "<strong>RT HEALTH AMBULANCE COVER</strong>",
        description: "Residents of Tasmania are covered by a reciprocal state government ambulance scheme in all states except QLD and SA, so our Ambulance cover only applies where the state government scheme does not. If you or anyone else on the policy live in a different State or Territory to the residential address of the policy please contact RT Health."
      },
      QLD: {
        title: "<strong>RT HEALTH AMBULANCE COVER</strong>",
        description: "RT Health does not provide Ambulance cover to QLD Residents. QLD Residents have a State Government Ambulance scheme for emergency transportation, and medically necessary non-emergency transportation. Cover applies anywhere in Australia. If you or anyone else on the policy live in a different State or Territory to the residential address of the policy please contact RT Health."
      },
      NSW_ACT: {
        title: "<strong>RT HEALTH AMBULANCE COVER</strong>",
        description: "Unlimited cover for emergency transportation, and medically necessary non-emergency transportation per person per calendar year. Cover applies anywhere in Australia."
      },
      OTHER: {
        title: "<strong>RT HEALTH AMBULANCE COVER</strong>",
        description: "Emergency Ambulance is provided up to $5,000 per person per year for emergency ambulance attendance or transportation in the case of accident or illness. Cover applies anywhere in Australia. Your level of ambulance cover is based on the state the policy is held in. If you or anyone else on the policy live in a different State or Territory to the residential address of the policy please contact RT Health."
      }
    };

    this.isBroker = AonConfig.corporate.distribution_type === 'broker' || false;
    this.productType = ctrl.package.selectedPrice.type;
    this.state = ctrl.package.selectedPrice.state;

    this.showChequeOnly = () => {
      if (this.isBroker) {
        return false;
      }
      return ctrl.fieldsets.benefit_payment.cheque_only_option;
    }

    this.getAmbulanceCoverScript = () => {
      // Early exit if product type is not hospital or combined and if it is not a broker
      if (![0, 2].includes(this.productType) || !this.isBroker) return null;

      if (['NSW', 'ACT'].includes(this.state)) return AMBULANCE_COVER_SCRIPTS.NSW_ACT;
      if (this.state === 'QLD') return AMBULANCE_COVER_SCRIPTS.QLD;
      if (this.state === 'TAS') return AMBULANCE_COVER_SCRIPTS.TAS;
      if (['VIC', 'SA', 'WA', 'NT'].includes(this.state)) return AMBULANCE_COVER_SCRIPTS.OTHER;
    };

    this.isCreditCardPayment = () => (
      _.get(ctrl.application, 'payment.type') === PaymentMethodsLookup.CREDIT_CARD
    );

    this.requiresBenefitsAccount = () => (
        _.get(ctrl.application, 'payment.type') !== PaymentMethodsLookup.BANK_ACCOUNT ||
        !_.get(ctrl.application, 'payment.benefits_same_account')
    );

    this.updatePaymentFrequencyOptions = () => {
      if (ctrl.application.payment.type === PaymentMethodsLookup.INVOICE) {
        // invoice payment - limited set of options
        const allowedFrequencies = [
          PaymentFrequenciesLookup.MONTHLY,
          PaymentFrequenciesLookup.QUARTERLY,
          PaymentFrequenciesLookup.HALF_YEARLY,
          PaymentFrequenciesLookup.YEARLY,
        ];

        this.paymentFrequencyOptions = ctrl.fieldsets.payment.frequency.choices
          .filter(([code]) => allowedFrequencies.includes(code));

        // If the frequency selected is no longer valid, clear it
        if (!allowedFrequencies.includes(ctrl.application.payment.frequency)) {
          _.set(ctrl.application, 'payment.frequency', undefined);
        }
      } else {
        // Reset to the full list of choices from the fieldsets
        this.paymentFrequencyOptions = ctrl.fieldsets.payment.frequency.choices;
      }
    }
    this.updatePaymentFrequencyOptions();

    $scope.$watch(
      'ctrl.application.payment.type',
      this.updatePaymentFrequencyOptions
    );

    $scope.$watch(
      'ctrl.application.policy.discount_code',
      // When employment group/discount code is changed, update pricing and sync with the operator filter
      () => {
        OperatorService.updateApplicantDependantFilters();
        ctrl.refetchPricing();
      }
    );
    this.debitDateDisabled = (date, mode) => {
        const dayOfWeek = date.getDay();
        const frequency = ctrl.application.payment.frequency;
        const isDirectDebit = ctrl.application.payment.type === PaymentMethodsLookup.BANK_ACCOUNT;
        if (frequency === PaymentFrequenciesLookup.FORTNIGHTLY && isDirectDebit) {
            return dayOfWeek !== 5;
        }
        return ctrl.debitDateDisabled(date, mode);
    };
    // ensure that available debit dates are updated when payment type is changed - parent
    // controller already watches payment frequency
    $scope.$watch('ctrl.application.payment.type', () => {
      ctrl.updateDebitDate();
    });
  });
}



// WEBPACK FOOTER //
// ./src/controllers/comparator/step3-ctrl-rte.js